let _endpoint = "";
let _clientId = "";

export const api = {
    setEndpoint(endpoint: string = "") {
        _endpoint = endpoint;
    },
    getEndpoint() {
        return _endpoint;
    },
    setClientId(clientId: string = "") {
        _clientId = clientId;
    },
    getClientId() {
        return _clientId;
    },
    async contactBackend<T>(endpointRoute: string, body: Record<string, unknown> = {}): Promise<T> {
        const response = await fetch(_endpoint + endpointRoute, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                clientId: _clientId,
                ...body
            })
        });

        if (!response.ok) {
            throw new Error("Request to backend failed");
        }

        return response.json();
    }
};
